import Image from 'next/image'
import { useVideoScale } from './useVideoScale'

type Props = {
  icon: string
  visible: boolean
}

export const FlashIcon = ({ icon, visible }: Props) => {
  const { videoScale } = useVideoScale()

  if (icon === '') {
    return null
  }

  return (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        height: `${videoScale * 72}px`,
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        color: 'white',
        padding: `${videoScale * 12}px ${videoScale * 20}px`,
        borderRadius: '8px',
        pointerEvents: 'none',
        opacity: visible ? 1 : 0,
        transition: 'all 0.2s cubic-bezier(0.3, 0.3, 0.3, 1)',
      }}
    >
      <Image
        src={`/player/${icon}.png`}
        alt='Icon'
        width={videoScale * 48}
        height={videoScale * 48}
      />
    </div>
  )
}
